import React, {useState} from 'react';

// Clients
import singularu from 'images/clients/singularu-MONEI.png';
import telefonica_logo from 'images/clients/telefonica-MONEI.png';
import blue_banana from 'images/clients/bluebanana-MONEI.png';
import marriot from 'images/clients/marriot-MONEI.png';
import scalpers from 'images/clients/scalpers-MONEI.png';
import universalmusic from 'images/clients/universal-MONEI.png';
import rowlogo from 'images/clients/elrow-MONEI.png';
import caixabanc from 'images/clients/caixabanc-MONEI.png';
import sonymusic from 'images/clients/sonymusic-MONEI.png';
import bbva from 'images/clients/bbva-MONEI.png';
import santander from 'images/clients/santander-MONEI.png';
import impress from 'images/clients/impress-MONEI.png';
import farma2gologo from 'images/clients/farma2go-MONEI.png';
import incapto from 'images/clients/incapto-MONEI.png';
import olistic from 'images/clients/olistic-MONEI.png';
import betis from 'images/clients/betis-MONEI.png';
import poloclub from 'images/clients/poloclub-MONEI.png';
import farmacaiasDirect from 'images/clients/farmaciasdirect-MONEI.png';
import hofflogo from 'images/clients/hoff-MONEI.png';
import ulanka from 'images/clients/ulanka-MONEI.png';
import mahou from 'images/clients/mahou-MONEI.png';
import gobik from 'images/clients/gobik-MONEI.png';
import meller from 'images/clients/meller-MONEI.png';
import drfranklin from 'images/clients/drfranklin-MONEI.png';
import taxitronic from 'images/clients/taxitronic-MONEI.png';
import styled from 'styled-components';
import {LanguageType} from '../../locales/types';
import {StyledDiv} from './StyledSx';
import {ScreenSizes, Sx} from '../../types/responsive';
import {useKeenSlider} from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

export type Client = {
  url: string | LanguageType;
  logo: string;
  alt: string;
  width: number;
  scale: number;
};

type Props = {
  clientList?: Client[];
  isSlider?: boolean;
};

export const defaultClientList: Client[] = [
  {
    logo: telefonica_logo,
    url: {
      es: 'https://www.telefonica.es/es/',
      en: 'https://www.telefonica.com/en/'
    },
    alt: 'Telefonica',
    width: 180,
    scale: 1
  },
  {
    logo: marriot,
    url: {
      es: 'https://www.espanol.marriott.com',
      fr: 'https://www.marriott.fr',
      pt: 'https://www.marriott.com.br',
      de: 'https://www.marriott.de',
      it: 'https://www.marriott.it',
      en: 'https://www.marriott.com'
    },
    alt: 'Marriot payment gateway',
    width: 160,
    scale: 0.9
  },
  {
    logo: scalpers,
    url: {
      es: 'https://www.scalpers.com/',
      pt: 'https://pt.scalperscompany.com/',
      fr: 'https://fr.scalperscompany.com/',
      de: 'https://de.scalperscompany.com/',
      en: 'https://en.eu.scalperscompany.com/'
    },
    alt: 'Scalpers payment gateway',
    width: 180,
    scale: 1
  },
  {
    logo: blue_banana,
    url: {
      es: 'https://www.bluebananabrand.com/',
      pt: 'https://www.bluebananabrand.com/pt/',
      fr: 'https://www.bluebananabrand.com/fr/',
      de: 'https://www.bluebananabrand.com/de/',
      en: 'https://www.bluebananabrand.com/en/'
    },
    alt: 'Blue banana payment gateway',
    width: 180,
    scale: 1
  },
  {
    logo: singularu,
    url: {
      es: 'https://singularu.com/',
      pt: 'https://singularu.com/',
      fr: 'https://singularu.com/',
      de: 'https://singularu.com/',
      en: 'https://singularu.com/'
    },
    alt: 'Singularu payment gateway',
    width: 180,
    scale: 1
  },
  {
    logo: universalmusic,
    url: {
      es: 'https://universalmusic.es/',
      en: 'https://universalmusic.es/'
    },
    alt: 'Universal Music',
    width: 180,
    scale: 1
  },
  {
    logo: rowlogo,
    url: {
      es: 'https://elrow.com/',
      en: 'https://elrow.com/'
    },
    alt: 'El row',
    width: 150,
    scale: 1
  },
  {
    logo: sonymusic,
    url: {
      es: 'https://sonymusic.es/',
      en: 'https://sonymusic.es/'
    },
    alt: 'Sony Music',
    width: 140,
    scale: 1
  },
  {
    logo: santander,
    url: {
      es: 'https://www.bancosantander.es/particulares',
      en: 'https://www.bancosantander.es/particulares'
    },
    alt: 'Santander',
    width: 160,
    scale: 1
  },
  {
    logo: bbva,
    url: {
      es: 'https://www.bbva.es/personas.html',
      en: 'https://www.bbva.es/personas.html'
    },
    alt: 'BBVA',
    width: 110,
    scale: 1
  },
  {
    logo: caixabanc,
    url: {
      es: 'https://www.caixabank.es/',
      en: 'https://www.caixabank.es/'
    },
    alt: 'CaixaBank',
    width: 180,
    scale: 1
  },
  {
    logo: impress,
    url: {
      es: 'https://smile2impress.com/es',
      en: 'https://smile2impress.com/es'
    },
    alt: 'Impress',
    width: 180,
    scale: 1
  },
  {
    logo: hofflogo,
    url: {
      es: 'https://thehoffbrand.com/',
      en: 'https://thehoffbrand.com/'
    },
    alt: 'HOFF',
    width: 160,
    scale: 1
  },
  {
    logo: farma2gologo,
    url: {
      es: 'https://www.farma2go.com/',
      en: 'https://www.farma2go.com/'
    },
    alt: 'Farma2go',
    width: 150,
    scale: 1
  },
  {
    logo: farmacaiasDirect,
    url: {
      es: 'https://www.farmaciadirect.es/',
      en: 'https://www.farmaciadirect.es/'
    },
    alt: 'Farmacias Directas',
    width: 300,
    scale: 1
  },
  {
    logo: incapto,
    url: {
      es: 'https://www.incapto.com/',
      en: 'https://www.incapto.com/'
    },
    alt: 'Incapto',
    width: 170,
    scale: 1
  },
  {
    logo: gobik,
    url: {
      es: 'https://www.gobik.es/',
      en: 'https://www.gobik.es/'
    },
    alt: 'Gobik',
    width: 190,
    scale: 1
  },
  {
    logo: taxitronic,
    url: {
      es: 'https://www.taxitronic.es/',
      en: 'https://www.taxitronic.es/'
    },
    alt: 'Taxitronic',
    width: 180,
    scale: 1
  },
  {
    logo: betis,
    url: {
      es: 'https://www.realbetisbalompie.es/',
      en: 'https://www.realbetisbalompie.es/'
    },
    alt: 'Betis',
    width: 130,
    scale: 1
  },
  {
    logo: ulanka,
    url: {
      es: 'https://www.ulanka.com/',
      en: 'https://www.ulanka.com/'
    },
    alt: 'Ulanka',
    width: 140,
    scale: 1
  },
  {
    logo: drfranklin,
    url: {
      es: 'https://es.dfranklincreation.com/',
      en: 'https://es.dfranklincreation.com/'
    },
    alt: 'Dr Franklin',
    width: 180,
    scale: 1
  },
  {
    logo: meller,
    url: {
      es: 'https://www.mellerbrand.com/',
      en: 'https://www.mellerbrand.com/'
    },
    alt: 'Meller',
    width: 180,
    scale: 1
  },
  {
    logo: olistic,
    url: {
      es: 'https://www.olisticscience.com',
      en: 'https://www.olisticscience.com'
    },
    alt: 'Olistic',
    width: 140,
    scale: 1
  },
  {
    logo: poloclub,
    url: {
      es: 'https://www.poloclub.com/',
      en: 'https://www.poloclub.com/'
    },
    alt: 'Poloclub',
    width: 300,
    scale: 1
  },
  {
    logo: mahou,
    url: {
      es: 'https://www.mahou.es/',
      en: 'https://www.mahou.es/'
    },
    alt: 'Mahou',
    width: 300,
    scale: 1
  }
].sort((a, b) => a.alt.localeCompare(b.alt));

const ClientsContainer = styled(StyledDiv)<{isSlider?: boolean}>`
  margin-top: 1rem;
  margin-bottom: 2rem;
  ${({isSlider}) =>
    isSlider
      ? `
    position: relative;
    overflow: hidden;
    width: 100%;
    
    @media (max-width: ${ScreenSizes.md}) {
      padding: 0 20px;
    }
  `
      : `
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    grid-gap: 0 2rem;

    @media (max-width: ${ScreenSizes.md}) {
      justify-content: space-evenly;
    }
    @media (max-width: ${ScreenSizes.sm}) {
      flex-direction: column;
    }
  `}
`;

const StyledClientLogo = styled.div<{isSlider?: boolean}>`
  opacity: 0.7;
  transition: 250ms opacity;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;

  :hover {
    opacity: 1;
  }

  img {
    margin: 0;
  }

  @media (max-width: 768px) {
    margin: 0;
    max-width: 100%;
  }
`;

const ArrowContainer = styled.div<{left?: boolean; right?: boolean}>`
  position: absolute;
  width: 28px;
  height: 28px;
  margin: 0;
  border-radius: 50%;
  background-color: rgba(17, 17, 17, 15%);
  top: calc(50% - 16px);
  left: ${(props) => (props.left ? '6px' : 'unset')};
  right: ${(props) => (props.right ? '6px' : 'unset')};
  z-index: 100;
  cursor: pointer;
  display: none;

  @media (max-width: ${ScreenSizes.md}) {
    display: block;
  }

  svg {
    position: absolute;
    width: 18px;
    height: 18px;
    left: calc(50% - 9px);
    top: calc(50% - 9px);
    path {
      fill: rgb(255, 255, 255);
    }
  }

  &:hover {
    box-shadow: rgb(0 0 0 / 50%) 0 4px 12px 0;
    background-color: rgba(17, 17, 17);
  }
`;

const SliderArrow: React.FC<{
  left?: boolean;
  right?: boolean;
  onClick: () => void;
}> = ({left, right, onClick}) => {
  return (
    <ArrowContainer onClick={onClick} left={left} right={right}>
      {left && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.2 24.1">
          <path fill="currentColor" d="M12.05,24.1l-12-12L12.05,0,14.2,2.15l-9.9,9.9L14.2,22Z" />
        </svg>
      )}
      {right && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.2 24.1">
          <path fill="currentColor" d="M2.15,24.1,0,22l9.9-9.9L0,2.15,2.15,0l12,12.05Z" />
        </svg>
      )}
    </ArrowContainer>
  );
};

const ClientLogo: React.FC<{
  isSlider?: boolean;
  src: string;
  alt: string;
  width: number;
}> = ({isSlider, src, alt, width}) => (
  <StyledClientLogo className={isSlider ? 'keen-slider__slide' : ''} isSlider={isSlider}>
    <img src={src} alt={alt} width={width} />
  </StyledClientLogo>
);

export const Clients: React.FC<Props & React.HTMLAttributes<any> & {sx?: Sx}> = ({
  clientList = defaultClientList,
  isSlider = false,
  ...props
}) => {
  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    loop: true,
    mode: 'snap',
    slides: {perView: 6, spacing: 30},
    breakpoints: {
      ['(max-width: ' + ScreenSizes.lg + ')']: {
        slides: {perView: 5, spacing: 20}
      },
      ['(max-width: ' + ScreenSizes.md + ')']: {
        slides: {perView: 4, spacing: 20}
      },
      ['(max-width: ' + ScreenSizes.sm + ')']: {
        slides: {perView: 3, spacing: 15}
      },
      ['(max-width: ' + ScreenSizes.xs + ')']: {
        slides: {perView: 3, spacing: 15}
      }
    },
    created(s) {
      s.moveToIdx(1, true, {duration: 0});
    },
    animationEnded(s) {
      setTimeout(() => {
        s.next();
      }, 1000);
    }
  });

  if (!isSlider) {
    return (
      <ClientsContainer isSlider={false} {...props}>
        {clientList.map((client) => (
          <ClientLogo
            key={client.alt}
            src={client.logo}
            alt={client.alt + '-MONEI'}
            width={client.width}
            isSlider={false}
          />
        ))}
      </ClientsContainer>
    );
  }

  return (
    <>
      {sliderRef && (
        <ClientsContainer isSlider {...props}>
          <div ref={sliderRef} className="keen-slider">
            {clientList.map((client) => (
              <ClientLogo
                key={client.alt}
                src={client.logo}
                alt={client.alt + '-MONEI'}
                width={client.width}
                isSlider
              />
            ))}
          </div>
        </ClientsContainer>
      )}
    </>
  );
};
